// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// @ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

/*
    DEPRECATED
    Paid Service Row

    This component is no longer used.  It has been replaced by ProfessionalServices &
    ProfessionalServices
*/

export default function PaidServiceRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['PaidService']

   // If the paid service is not in the pricebook, do not show the row
   if (state.product_list['paidService']?.NotInPricebook) {
      return <> </>
   }

   // If the paid service amount is 0, do not show the row
   if (Number(state.productPaidServiceAmount) === 0) {
      return <> </>
   }

   return (
      <div className='row'>
         <div className='col-bhr1'>
            {state.product_list['paidService']['ProductName'].replace(
               '$',
               state.currencyObject.Symbol,
            )}
         </div>
         <div className='col-bhr2'>
            <input
               className='form-control'
               type='number'
               step='0.01'
               value={
                  state.productPaidServiceAmount <= 0
                     ? ''
                     : state.productPaidServiceAmount.toString()
               }
               onChange={(e) =>
                  state.onProductPaidServiceAmountChange(Number(e.target.value))
               }
               onBlur={() =>
                  state.onProductPaidServiceAmountChange(
                     Math.floor(state.productPaidServiceAmount * 100) / 100,
                  )
               }
               min={0}
               placeholder={'0'}
            />
         </div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'>
            {formatFloatAsCurrencySymbol(
               state.PaidServiceCosts.totalPrice,
               state.currencyObject,
            )}
         </div>
         {state.differenceQuote == true ? (
            <>
               <div className='col'></div>
               <div className='col'></div>
            </>
         ) : (
            <></>
         )}
      </div>
   )
}
